import { trackProductImpression } from "core/tracking/controller";
export function trackHero(typename, variant, category, trackingUuid, item) {
    var impression = {
        list: typename,
        id: trackingUuid,
        name: item.title,
        category: category,
        variant: variant,
    };
    trackProductImpression([impression]);
}
